<h1 mat-dialog-title>Solicitud de cambio</h1>

<mat-dialog-content [formGroup]="form">
  <div class="form-fields">
    <mat-form-field appearance="outline" class="full-width-field" subscriptSizing="dynamic">
      <mat-label>Fecha propuesta</mat-label>
      <input matInput type="datetime-local" formControlName="proposed_date" />
      @if (form.get('proposed_date')?.hasError('required') && (form.get('proposed_date')?.touched || form.get('proposed_date')?.dirty)) {
        <mat-error>La fecha es obligatoria</mat-error>
      } @else if (
        form.get('proposed_date')?.hasError('futureDate') && (form.get('proposed_date')?.touched || form.get('proposed_date')?.dirty)
      ) {
        <mat-error>La fecha no puede ser futura</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width-field" subscriptSizing="dynamic">
      <mat-label>Descripción</mat-label>
      <textarea matInput formControlName="justification" rows="3"></textarea>
      @if (
        form.get('justification')?.hasError('required') &&
        (submitted() || form.get('justification')?.touched || form.get('justification')?.dirty)
      ) {
        <mat-error>La descripción es obligatoria</mat-error>
      } @else if (
        form.get('justification')?.hasError('minlength') &&
        (submitted() || form.get('justification')?.touched || form.get('justification')?.dirty)
      ) {
        <mat-error>Mínimo {{ justification_min_length }} caracteres.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width-field" subscriptSizing="dynamic">
      <mat-label>Ubicación del fichaje</mat-label>
      <mat-select formControlName="proposed_location_id" placeholder="Seleccionar">
        <mat-option [value]="null">Seleccionar</mat-option>
        @for (location of locations(); track location.id) {
          <mat-option [value]="location.id">{{ location.name }}</mat-option>
        }
      </mat-select>
      @if (submitted() && (form.hasError('noChangeProposed') || form.get('proposed_location_id')?.hasError('noChangeProposed'))) {
        <mat-error>Debes modificar la fecha o la ubicación respecto al fichaje actual.</mat-error>
      }
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" (click)="save()" [disabled]="saving()" type="submit">
    @if (saving()) {
      Solicitando…
    } @else {
      Solicitar cambio
    }
  </button>
</mat-dialog-actions>
